<template>
    <svg
    class="svgEdit"
        @click="clicked"
            @mouseout="mouseover"
            @mouseleave="mouseleave"
            @mouseenter="mouseenter"
            @mousedown="mousedown"
               width="18" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    >  
    <path d="M7.7093 2.68665H2.49096C2.09553 2.68665 1.7163 2.8542 1.43669 3.15245C1.15708 3.45071 1 3.85522 1 4.27702V15.4096C1 15.8314 1.15708 16.2359 1.43669 16.5342C1.7163 16.8324 2.09553 17 2.49096 17H12.9276C13.3231 17 13.7023 16.8324 13.9819 16.5342C14.2615 16.2359 14.4186 15.8314 14.4186 15.4096V9.84331" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.3002 1.49406C13.5967 1.17772 13.999 1 14.4184 1C14.8378 1 15.24 1.17772 15.5366 1.49406C15.8332 1.81041 15.9998 2.23946 15.9998 2.68684C15.9998 3.13422 15.8332 3.56328 15.5366 3.87962L8.45457 11.4339L5.47266 12.2291L6.21813 9.04833L13.3002 1.49406Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
<script>
export default {
    props:["color"],
    methods: {
        clicked() {
            this.$emit('clicked')
        },
        mouseover() {
            this.$emit('mouseover')
        },
        mouseleave() {
            this.$emit('mouseleave')
        },
        mousedown() {
            this.$emit('mousedown')
        },
        mouseenter() {
            this.$emit('mouseenter')
        },
    }
}
</script>
<style>
.svgEdit:hover path {
    stroke:#EF2035;
    stroke-width:2;
}
.svgEdit:hover circle {
    stroke:#EF2035;
    stroke-width:6;
    cursor:pointer;
}
</style>